import { api } from "./axios";
import { makeFilterString } from './utils';

export async function getAllOrders(objFilter) {
    let res = await api.get("order/getAllOrders/" + makeFilterString(objFilter));
    if (res) return res.data.data;
    else return false;
}
export async function getOrdersByFilter(objFilter, objPagination) {
    let res = await api.post("order/date_filter/" + makeFilterString(objPagination), objFilter);
    if (res) return res.data.data;
    else return false;
}
export async function getOrderDetails(id) {
    let res = await api.get("order/get/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function getOrderManual(objFilter) {
    let res = await api.get("order/manual/" + makeFilterString(objFilter));
    if (res) return res.data.data;
    else return false;
}

export async function updateOrderPricing(data) {
    let res = await api.post("order/pricing", data);
    if (res) return res.status;
    else return false;
}

export async function getPaymentFilter(data) {
    let res = await api.post("order/payment_filter", data);
    if (res) return res.data;
    else return false;
}

export async function getOthersOrders() {
    let res = await api.get("order/others");
    if (res) return res.data;
    else return false;
}

export async function unListOrder(orderId) {
    let res = await api.get("order/unlist/" + orderId);
    if (res) return res;
    else return false;
}

export async function getOthersOrdersPagination(objPagination) {
    let res = await api.get("order/others" + makeFilterString(objPagination));
    if (res) return res.data;
    else return false;
}




